import React, {useEffect} from 'react'
import { useLocation } from "react-router-dom";
import VermouthLine from '../components/VermouthLine'
import WineLine from '../components/WineLine'
import Footer from '../components/Footer';

const Drinks = ({lang, translations}) => {
const { pathname } = useLocation();
   useEffect(() => {
          window.scrollTo(0, 0); 
        }, [pathname]); 

  const wines = [
    { name: 'Lacuesta Rojo', price: '4,00€' },
    { name: 'Cala Morisca', price: '4,00€' },
    { name: 'Lustau Rojo', price: '4,50€' },
    { name: 'Lustau Rosé', price: '4,50€' },
    { name: 'Lustau Blanco', price: '4,50€' },
    { name: 'Miró Rojo', price: '4,00€' },
    { name: 'Miró Blanco', price: '4,00€' },
    { name: 'Rivera', price: '4,50€' },
  ];

  return (
    <div>
      <div className='flex margin-top-15'>
        <div className='menu-background'>
          <div className='margin-top-20'>
            <img src='img/titulovermouth.PNG' alt='titulo vermouth'/>
        <VermouthLine name={translations[lang].vermouth1} price={'4,00€'} />
        <VermouthLine name={translations[lang].vermouth2} price={'4,00€'} />
        <VermouthLine name={translations[lang].vermouth3} price={'4,50€'} />
        <VermouthLine name={translations[lang].vermouth4} price={'4,50€'} />
        <VermouthLine name={translations[lang].vermouth5} price={'4,50€'} />
        <VermouthLine name={translations[lang].vermouth6} price={'4,00€'} />
        <VermouthLine name={translations[lang].vermouth7} price={'4,00€'} />
        <VermouthLine name={translations[lang].vermouth8} price={'4,50€'} />
      {wines.map((item, index) => (
        <WineLine key={index} name={item.name} price={item.price} />
      ))}
      </div>
      </div>
      </div>
       <Footer lang={lang} translations={translations}/>
    </div>
  )
}

export default Drinks